import * as React from 'react';
import { ConfiguratorContext } from './ConfigContextProvider';
import { isReadOnly, fromInt, useValidation, getOptionModel, configEventControlType, configEvents, setOptionValueChanged, useRefreshKey } from './ProductConfiguratorShared';
import { AccentLengthUnbound } from '../unbound/AccentLengthUnbound';

export const ConfigLength = props => {

    const focusBug = React.useRef(false);

    const ctx = React.useContext(ConfiguratorContext)
    const optionModel = getOptionModel(ctx, props.optionID);


    const settings = optionModel.GetLengthSettings();

    
    const validation = useValidation(props.optionID, "ConfigLength");

    const [value, setValue] = React.useState(optionModel.CurrentValue);

    const refreshKey = useRefreshKey(props.optionID, value);

    const onChange = React.useCallback(e => {

        focusBug.current = false;

        console.log("ConfigLength: ", e.toString());

        optionModel.UpdateFrom$1(e);

        setOptionValueChanged(ctx, optionModel);

        setValue(e);

    }, [setValue, ctx, optionModel]);

    const onFocus = React.useCallback(e => {
        if (!focusBug.current) {
            focusBug.current = true;
            ctx.config?.Publish(configEvents.controlGotFocus, configEventControlType.decimal);
        }

    }, [ctx]);

    const notifyDirty = React.useCallback(e => {

        if (ctx.notifyDirty) {
            ctx.notifyDirty();
        }

    }, [ctx]);

    const readOnly = isReadOnly(optionModel);

    const min = fromInt(optionModel.MinValue);
    const max = fromInt(optionModel.MaxValue);


    

    return <div className="config-control config-decimal">
        <AccentLengthUnbound
            key={refreshKey.refreshID}
            defaultUnit={settings?.Unit ?? 10}
            precision={settings?.Precision}
            required={validation.required}
            defaultValue={optionModel.CurrentValue}
            onBlur={onChange}
            onChange={notifyDirty}
            onFocus={onFocus}
            disabled={readOnly}
            min={min}
            max={max === 0 ? undefined : max}
            debounceMilliseconds={50}
        />
    </div>;

};